import React from "react";
import { Row } from "@amzn/stencil-react-components/layout";
import { Label } from "@amzn/stencil-react-components/text";
import "src/components/commonStyles.scss";
import {TimestampInput} from "src/components/authoringComponents/TimestampInput";
import {TimestampInputValidity} from "src/constant/constants";

const STRINGS_DISPLAYED = {
    valid_from_label: "Valid From",
    valid_till_label: "Valid Till",
}

const TOOLTIP_TEXT = {
    valid_from_label: "Valid from determines from what instant the event model will be live. " +
        "Leaving this value as empty would mean that the event model would be live as soon as it is published",
    valid_till_label: "Valid till determines when the event model will expire. " +
        "Leaving this field value as empty would mean that the event model will not expire.",
}

/**
 * Renders the timestamp selector component.
 */
export const EventTimestampSelector = () => {

    return <>
        <Row
            alignItems={"center"}
            justifyContent={"space-between"}
            width={"fit-content"}
        >
            <Label
                fontSize={"20px"}
                fontWeight={"bold"}
                htmlFor="valid-from-label"
                className={"width_200_px"}
            >
                {STRINGS_DISPLAYED.valid_from_label}
            </Label>
            <TimestampInput attributeName={TimestampInputValidity.VALID_FROM} tooltipText={TOOLTIP_TEXT.valid_from_label}/>
        </Row>
        <Row
            alignItems={"center"}
            justifyContent={"space-between"}
            width={"fit-content"}
        >
            <Label
                fontSize={"20px"}
                fontWeight={"bold"}
                htmlFor="valid-till-label"
                className={"width_200_px"}
            >
                {STRINGS_DISPLAYED.valid_till_label}
            </Label>
            <TimestampInput attributeName={TimestampInputValidity.VALID_TILL} tooltipText={TOOLTIP_TEXT.valid_till_label}/>
        </Row>
    </>
}
